<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/150eqve/tc-custom/9780300248982.jpg?1728954778235" alt="This image is the cover for the book Polygamy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Polygamy
      </h1>
      <p class="bookDescription body article font2">
        <b>A groundbreaking examination of polygamy showing that monogamy was not the only form marriage took in early America</b><br/><br/><b>"A richly sourced, elegantly written, and strikingly original interdisciplinary study of the diverse practices of polygamy in American from ca.1500 to 1900.”—John Witte Jr.,<i> Journal of Law and Religion</i></b><br/><br/>Today we tend to think of polygamy as an unnatural marital arrangement characteristic of fringe sects or uncivilized peoples. Historian Sarah Pearsall shows us that polygamy’s surprising history encompasses numerous colonies, indigenous communities, and segments of the American nation. Polygamy—as well as the fight against it—illuminates many touchstones of American history: the Pueblo Revolt and other uprisings against the Spanish; Catholic missions in New France; New England settlements and King Philip’s War; the entrenchment of African slavery in the Chesapeake; the Atlantic Enlightenment; the American Revolution; missions and settlement in the West; and the rise of Mormonism.<br/><br/>Pearsall expertly opens up broader questions about monogamy’s emergence as the only marital option, tracing the impact of colonial events on property, theology, feminism, imperialism, and the regulation of sexuality. She shows that heterosexual monogamy was never the only model of marriage in North America.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        M. S. Pearsall
      </h2>
      
      <p class="authorDescription body article">Sarah M. S. Pearsall teaches the history of early America and the Atlantic world at the University of Cambridge. She is the author of the prizewinning Atlantic Families: Lives and Letters in the Eighteenth Century.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Yale University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7c95eb2c